var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoArenaLp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 484.323,
    height: 284.141,
    viewBox: "0 0 484.323 284.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1965",
    x: 0,
    y: 0,
    width: 102.366,
    height: 172.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1966",
    x: 86.127,
    y: 0,
    width: 105.235,
    height: 172.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1967",
    x: 236.19,
    y: 0,
    width: 112.406,
    height: 172.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1968",
    x: 310.391,
    y: 0,
    width: 102.367,
    height: 172.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1969",
    x: 164.933,
    y: 0,
    width: 106.443,
    height: 172.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1970",
    x: 61.164,
    y: 164.832,
    width: 76.434,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1971",
    x: 14.179,
    y: 164.832,
    width: 82.791,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1972",
    x: 225.589,
    y: 164.832,
    width: 108.936,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1973",
    x: 300.87,
    y: 163.35,
    width: 76.577,
    height: 120.79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1974",
    x: 115.702,
    y: 164.832,
    width: 78.25,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1975",
    x: 348.094,
    y: 164.832,
    width: 78.25,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1976",
    x: 165.603,
    y: 164.832,
    width: 79.397,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_1977",
    x: 397.995,
    y: 164.832,
    width: 86.328,
    height: 117.779,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-arena-lp",
    transform: "translate(-414 -272.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4967",
    "data-name": "Grupo 4967",
    transform: "translate(-3984.06 737.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1950",
    "data-name": "Caminho 1950",
    d: "M397.023,179.835h4.439l11.105-52.249h-4.439Z",
    transform: "translate(4174.667 -528.785)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1951",
    "data-name": "Caminho 1951",
    d: "M581.114,255.928l-9.333,43.91H575.2l9.332-43.91h-3.415Z",
    transform: "translate(4071.054 -604.879)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1952",
    "data-name": "Caminho 1952",
    d: "M626.312,0,615.272,51.941h1.708L628.019,0Z",
    transform: "translate(4045.268 -453.141)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1953",
    "data-name": "Caminho 1953",
    d: "M256.864,0,245.824,51.941h2.049L258.913,0Z",
    transform: "translate(4264.312 -453.141)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1954",
    "data-name": "Caminho 1954",
    d: "M934.125,127.585l-2.412,43.622-.694,8.627h2.39l.694-8.627,2.412-43.622Z",
    transform: "translate(3858.064 -528.785)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1955",
    "data-name": "Caminho 1955",
    d: "M77.211,171.208h2.732l15.022-43.622H92.233Z",
    transform: "translate(4364.282 -528.785)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1956",
    "data-name": "Caminho 1956",
    d: "M781.25,0,770.21,51.941h5.464L786.714,0Z",
    transform: "translate(3953.406 -453.141)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1957",
    "data-name": "Caminho 1957",
    d: "M496.886,82.612h3.074l6.593-30.881H503.48Z",
    transform: "translate(4115.458 -483.812)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1958",
    "data-name": "Caminho 1958",
    d: "M601.159,0l-4.453,21.06h3.074L604.233,0Z",
    transform: "translate(4056.276 -453.141)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1959",
    "data-name": "Caminho 1959",
    d: "M301.657,255.928h-2.732l3.663,43.91h4.1l-3.664-43.91Z",
    transform: "translate(4232.829 -604.879)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1960",
    "data-name": "Caminho 1960",
    d: "M669.255,255.928h-2.391l.957,43.91h3.756l-.957-43.91Z",
    transform: "translate(4014.68 -604.879)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1961",
    "data-name": "Caminho 1961",
    d: "M405.241,255.928l-9.333,43.91h3.756L409,255.928h-3.756Z",
    transform: "translate(4175.328 -604.879)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1962",
    "data-name": "Caminho 1962",
    d: "M335.065,51.731h-2.049q7.548,0,7.549,6.643a15.677,15.677,0,0,1-.453,3.472l-4.365,20.766H337.8l4.365-20.766a15.674,15.674,0,0,0,.453-3.472q0-6.642-7.549-6.643",
    transform: "translate(4212.616 -483.812)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1963",
    "data-name": "Caminho 1963",
    d: "M854.667,127.585l-15.022,43.622h2.391l15.022-43.622Z",
    transform: "translate(3912.239 -528.785)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1964",
    "data-name": "Caminho 1964",
    d: "M169.279,171.208l-.694,8.627h2.732l.694-8.627,2.412-43.622h-2.732Z",
    transform: "translate(4310.106 -528.785)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1965-2",
    "data-name": "Caminho 1965",
    d: "M21.514,148.1l10.87-31.4H54.2l-2.491,31.4H73.3l3.533-43.91h-8.2l.694-8.627,2.412-43.622H75.5L78.367,0H49.079L29.842,51.941H26.086L9.846,95.79l-2.9,8.4h8.2L0,148.1ZM49.188,51.941h1.025L56.4,33.968,54.97,51.941H51.214L47.738,95.563h-16.3L46.455,51.941Z",
    transform: "translate(12 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1966-2",
    "data-name": "Caminho 1966",
    d: "M232.923,148.1l9.315-43.91h-8.2l4.424-20.855,2.793-.377,1.772,21.233h8.2l3.664,43.91h23.4l-5.964-43.91h-8.2l-3.4-25.007q18.116-6.188,22.344-25.74l.315-1.5h3.756l4.365-20.766A50.479,50.479,0,0,0,292.8,20.532Q292.8.076,269.7,0H238.6L227.559,51.941H223.8L212.7,104.19h8.2l-9.333,43.91Zm13.941-96.159h2.049l6.594-30.881h7.548q7.548,0,7.549,6.643a15.677,15.677,0,0,1-.453,3.472l-4.365,20.766H262.03l-.316,1.5q-1.511,7.1-7.85,9.435a22.309,22.309,0,0,1-6.265.6h-4.907l2.465-11.542Z",
    transform: "translate(-113.43 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1967-2",
    "data-name": "Caminho 1967",
    d: "M586.087,104.19H589.5l-9.333,43.91H600.7l9.324-43.91h-8.2l8.339-39.273.856,39.273h8.2l.957,43.91h21.362l9.333-43.91h-8.2l11.1-52.249h3.756L668.576,0H648.8L637.753,51.941H634L626.775,85.9,626,51.941h3.757L628.569,0H607.207l-11.04,51.941h-3.756L581.306,104.19Z",
    transform: "translate(-331.98 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1968-2",
    "data-name": "Caminho 1968",
    d: "M769.382,104.19h8.2L762.434,148.1h21.512l10.87-31.4h21.815l-2.491,31.4h21.588l3.533-43.91h-8.2l.694-8.627,2.412-43.622h3.756L840.8,0H811.513L792.275,51.941h-3.756L772.279,95.79Zm41.9-52.249h1.366l6.189-17.973L817.4,51.941h-3.757l-3.475,43.622h-16.3l15.022-43.622Z",
    transform: "translate(-440.04 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1969-2",
    "data-name": "Caminho 1969",
    d: "M456.662,84.618H461.1l4.454-21.135H436.267l2.464-11.542h3.756l6.594-30.881h34.043L487.579,0H432.173L421.134,51.941h-3.756L406.272,104.19h8.2l-9.332,43.91h55.405l4.453-21.06H430.951l4.879-22.85h-8.2l4.179-19.572Z",
    transform: "translate(-228.2 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1970)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1970-2",
    "data-name": "Caminho 1970",
    d: "M161.666,465.543l-11.423,33.124h13.622l6.883-19.884h13.814l-1.578,19.884h13.67l2.677-33.267,3.346-60.512H184.132Zm23.995-.143H175.337l13.431-39Z",
    transform: "translate(-77.08 -228.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1971-2",
    "data-name": "Caminho 1971",
    d: "M80.095,404.888l-8.556,40.2H59.733l8.556-40.2H54.762L34.83,498.666H48.357l8.556-40.2H68.719l-8.556,40.2H73.69l19.932-93.779Z",
    transform: "translate(-8.65 -228.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1972-2",
    "data-name": "Caminho 1972",
    d: "M625.4,404.888l-24.9,72.27,5.784-72.27H592.846l-24.9,72.27,5.783-72.27H560.1l-2.629,33.171-3.346,60.607h18.545l17.255-48.419-3.25,48.419h18.545l22.37-60.512,11.471-33.267Z",
    transform: "translate(-316.54 -228.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1973-2",
    "data-name": "Caminho 1973",
    d: "M791.625,414.584q0-13.336-16.012-13.336-19.406,0-23.612,19.693L739.813,478.3a30.554,30.554,0,0,0-.765,6.4q0,13.336,15.964,13.335,19.453-.048,23.66-19.74l12.189-57.358a29.942,29.942,0,0,0,.765-6.357m-14.291,6.357L765.145,478.3q-1.339,6.357-7.265,6.357-4.78,0-4.78-4.206a11.069,11.069,0,0,1,.239-2.151l12.188-57.358q1.338-6.356,7.169-6.357h.1q4.779.048,4.78,4.254a10.39,10.39,0,0,1-.239,2.1",
    transform: "translate(-426.18 -225.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1974-2",
    "data-name": "Caminho 1974",
    d: "M334.681,438.729l2.964-14.1a31.948,31.948,0,0,0,.812-6.739q0-12.953-14.626-13H304.138l-19.932,93.779h13.527l8.7-41.01,1.768-.239,3.441,41.249H326.46l-5.927-43.639q11.471-3.919,14.148-16.3m-10.563-14.1-2.963,14.1a7.593,7.593,0,0,1-4.971,5.975,14.13,14.13,0,0,1-3.967.382h-3.107l5.736-26.862h4.779q4.78,0,4.78,4.206a9.93,9.93,0,0,1-.287,2.2",
    transform: "translate(-156.5 -228.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1975-2",
    "data-name": "Caminho 1975",
    d: "M905.522,438.729l2.964-14.1a31.971,31.971,0,0,0,.812-6.739q0-12.953-14.626-13H874.979l-19.932,93.779h13.527l8.7-41.01,1.769-.239,3.441,41.249H897.3l-5.927-43.639q11.472-3.919,14.148-16.3m-10.563-14.1L892,438.729a7.593,7.593,0,0,1-4.971,5.975,14.129,14.129,0,0,1-3.967.382h-3.107l5.736-26.862h4.78q4.779,0,4.779,4.206a9.9,9.9,0,0,1-.286,2.2",
    transform: "translate(-494.95 -228.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1976-2",
    "data-name": "Caminho 1976",
    d: "M447.554,404.888h-20.84l-19.931,93.779h19.98q18.879-.047,23.086-19.693l11.519-54.346a31.95,31.95,0,0,0,.812-6.739q0-12.953-14.626-13m.287,19.74-11.52,54.346q-1.387,6.358-7.265,6.357h-5.927l14.292-67.108h5.927q4.779,0,4.779,4.206a9.93,9.93,0,0,1-.286,2.2",
    transform: "translate(-229.18 -228.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4398.06, -465.14)",
    filter: "url(#Caminho_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1977-2",
    "data-name": "Caminho 1977",
    d: "M1039.951,404.888h-14.483l-23.278,41.727,8.89-41.727H997.554l-19.931,93.779h13.526l8.843-41.679,5.544,41.679h14.483l-7.887-46.89Z",
    transform: "translate(-567.63 -228.06)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArenaLp);
export default __webpack_public_path__ + "static/media/logo-arena-lp.6820e6b3d126646cf98a0e77862e601f.svg";
export { ForwardRef as ReactComponent };